// THIRD PARTY -> HOST
// https://github.com/HubSpot/calling-extensions-sdk/blob/master/src/CallingExtensions.js
export const CALL_ANSWERED = 'CALL_ANSWERED';
export const CALL_COMPLETED = 'CALL_COMPLETED';
export const CALL_DATA = 'CALL_DATA';
export const CALL_ENDED = 'CALL_ENDED';
export const CALL_TRANSFERRED = 'CALL_TRANSFERRED';
export const ERROR = 'ERROR';
export const INCOMING_CALL = 'INCOMING_CALL';
export const INITIALIZED = 'INITIALIZED';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const NAVIGATE_TO_RECORD = 'NAVIGATE_TO_RECORD';
export const OUTGOING_CALL_STARTED = 'OUTGOING_CALL_STARTED';
export const PUBLISH_TO_CHANNEL = 'PUBLISH_TO_CHANNEL';
export const RESIZE_WIDGET = 'RESIZE_WIDGET';
export const SYNC_ACK = 'SYNC_ACK';
export const UNKNOWN_MESSAGE_TYPE = 'UNKNOWN_MESSAGE_TYPE';
export const USER_AVAILABLE = 'USER_AVAILABLE';
export const USER_UNAVAILABLE = 'USER_UNAVAILABLE';
export const SET_WIDGET_URL = 'SET_WIDGET_URL';

// IFRAME MANAGER -> CTI
export const READY = 'READY';
export const SYNC_ACK_FAILED = 'SYNC_ACK_FAILED';
const events = {
  CALL_ANSWERED,
  CALL_COMPLETED,
  CALL_DATA,
  CALL_ENDED,
  CALL_TRANSFERRED,
  ERROR,
  INCOMING_CALL,
  INITIALIZED,
  LOGGED_IN,
  LOGGED_OUT,
  NAVIGATE_TO_RECORD,
  OUTGOING_CALL_STARTED,
  PUBLISH_TO_CHANNEL,
  RESIZE_WIDGET,
  SYNC_ACK,
  UNKNOWN_MESSAGE_TYPE,
  USER_AVAILABLE,
  USER_UNAVAILABLE,
  SET_WIDGET_URL,
  READY,
  SYNC_ACK_FAILED
};